import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MonitoringImage } from '../../cctv-monitoring.models';
import { imageAge } from '../../cctv-monitoring.utils';

@Component({
  selector: 'app-image-tile',
  templateUrl: './image-tile.component.html',
  styleUrls: ['./image-tile.component.css'],
})
export class ImageTileComponent implements OnChanges {
  @Input() image!: MonitoringImage;
  @Input() pinned = false;
  @Input() ageTick = 0;
  @Output() readonly pin = new EventEmitter<void>();
  @Output() readonly zoom = new EventEmitter<void>();
  imageSrc = '';
  imageFailed = false;
  status = '';
  ageLabel = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.image) {
      this.imageSrc = this.image.thumbnailUrl;
      this.imageFailed = false;
    }
    if (changes.image || changes.ageTick) this.updateAge();
  }

  onImageError(): void {
    if (this.imageSrc !== this.image.fullUrl) this.imageSrc = this.image.fullUrl;
    else this.imageFailed = true;
  }

  private updateAge(): void {
    const age = imageAge(this.image);
    this.status = age === null ? 'نامشخص' : age <= 90 ? 'تازه' : age <= 180 ? 'تأخیردار' : 'قدیمی';
    if (age === null) {
      this.ageLabel = this.image.ageText || 'زمان نامشخص';
      return;
    }
    const value = age < 60 ? age : age < 3600 ? Math.floor(age / 60) :
      age < 86400 ? Math.floor(age / 3600) : Math.floor(age / 86400);
    const unit = age < 60 ? 'ثانیه' : age < 3600 ? 'دقیقه' : age < 86400 ? 'ساعت' : 'روز';
    this.ageLabel = `${value.toLocaleString('fa-IR')} ${unit} پیش`;
  }
}
